(ns frontend.view.settings.sys-admin.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::processing-toggle-marked-for-deletion?
 (fn [db]
   (get-in db [::processing-toggle-marked-for-deletion?])))

(rf/reg-sub
 ::processing-toggle-suspended?
 (fn [db]
   (get-in db [::processing-toggle-suspended?])))
